// Shipping is limited to the UAE and the GCC countries only.
export const REGIONS = ["UAE", "GCC"];

export const COUNTRIES = [
  { name: "United Arab Emirates", ar: "الإمارات العربية المتحدة", region: "UAE" },
  { name: "Saudi Arabia", ar: "السعودية", region: "GCC" },
  { name: "Qatar", ar: "قطر", region: "GCC" },
  { name: "Kuwait", ar: "الكويت", region: "GCC" },
  { name: "Bahrain", ar: "البحرين", region: "GCC" },
  { name: "Oman", ar: "عُمان", region: "GCC" },
];

export const regionForCountry = (name) => COUNTRIES.find((c) => c.name === name)?.region || "GCC";
